



























import { defineComponent, onUnmounted, ref } from "@vue/composition-api";
import { isSameDay, parseISO } from "date-fns";
import { Vue } from "vue/types/vue";
import { Announcement } from "@scrile/api-provider/dist/api/AnnouncementsProvider";
import { useAnnouncements } from "@/hooks/useAnnouncements";
import emitter from "@/lib/emitter";
import { formatDate } from "@/lib/time";
import { EVENTS } from "@/const";
import BasePage from "@/components/BasePage";
import CustomScroll from "@/components/CustomScroll";
import EmptyContent from "@/components/EmptyContent";
import PageTitle from "@/components/PageTitle";
import PageAnnouncementItem from "./components/PageAnnouncementItem.vue";

export default defineComponent({
  name: "PageAnnouncements",
  components: { EmptyContent, PageAnnouncementItem, CustomScroll, PageTitle, BasePage },
  setup() {
    const { announcements, loading, hasUnreadAnnouncement, getAnnouncements, readAnnouncement } = useAnnouncements();

    const list = ref<Vue | undefined>();

    const getDate = (date: string) => {
      return formatDate(new Date(date), { month: "long", day: "2-digit", year: "numeric" });
    };

    const isOtherDayItem = (items: Announcement[], index: number) => {
      if (index === 0) return true;
      return !isSameDay(parseISO(items[index - 1].time), parseISO(items[index].time));
    };

    const getData = async () => {
      await getAnnouncements();
      if (hasUnreadAnnouncement.value) {
        await readAnnouncement(announcements.value[0].id);
      }
    };

    const onNewAnnouncement = async () => {
      await getAnnouncements();
      await readAnnouncement(announcements.value[0].id);
    };

    getData();

    emitter.emit(EVENTS.MAIN_MENU_HIDE, true);
    emitter.on(EVENTS.ANNOUNCEMENT_NEW_ANNOUNCEMENT, onNewAnnouncement);
    onUnmounted(() => {
      emitter.emit(EVENTS.MAIN_MENU_HIDE, false);
      emitter.off(EVENTS.ANNOUNCEMENT_NEW_ANNOUNCEMENT, onNewAnnouncement);
    });

    return {
      list,
      announcements,
      loading,
      getDate,
      isOtherDayItem,
    };
  },
});
